import { useEffect, useState } from "react";
import type { BoardOperator } from "../../hooks/useOoDay";
import { useClampPop } from "./useClampPop";
import css from "./board.module.css";

/** МК-строка миниатюры (19.08, Саша): чипы [услуга — исполнитель] в рамочке
 *  цвета МК (--mc, 11.10); тап — обычный дропдаун операторов (назначить/снять), карточку НЕ
 *  раскрывает. Кандидаты и «✓ ведёт» — та же логика, что в развёрнутой панели. */
interface McAttachLite { key: string; mcId: string; mcName: string; operatorIds: string[] }

export function McMiniRow({ mc, operators, opName, candidates, onAddOp, onRemoveOp }: {
  mc: McAttachLite[];
  operators: BoardOperator[];
  opName: (id: string) => string;
  candidates: (operators: BoardOperator[], mcId: string, taken: string[]) => BoardOperator[];
  onAddOp: (key: string, opId: string) => void;
  onRemoveOp: (key: string, opId: string) => void;
}) {
  const [pick, setPick] = useState<string | null>(null);
  const popRef = useClampPop<HTMLDivElement>(pick);
  useEffect(() => { // закрытие тапом мимо
    if (!pick) return;
    const onDown = (e: PointerEvent) => { const t = e.target as HTMLElement | null; if (!t?.closest?.(`.${css.mkOplist}`) && !t?.closest?.(`.${css.mcChip}`)) setPick(null); };
    document.addEventListener("pointerdown", onDown, true);
    return () => document.removeEventListener("pointerdown", onDown, true);
  }, [pick]);
  return (
    <>
      {mc.map((a) => (
        <span key={a.key} className={css.addOpWrap}>
          <button type="button" className={css.mcChip} onClick={(e) => { e.stopPropagation(); setPick((p) => (p === a.key ? null : a.key)); }}>
            {a.mcName.replace(/^МК\s+/i, "")}{a.operatorIds.length ? ` — ${a.operatorIds.map(opName).join(", ")}` : " — ?"}
          </button>
          {pick === a.key ? (
            <div className={css.mkOplist} ref={popRef}>
              {a.operatorIds.map((opId) => (
                <button key={opId} type="button" className={css.opItem} onClick={() => { onRemoveOp(a.key, opId); setPick(null); }}><span className={css.opName} style={{ color: "var(--red)" }}>✕ {opName(opId)}</span></button>
              ))}
              {candidates(operators, a.mcId, a.operatorIds).map((o) => (
                <button key={o.id} type="button" className={css.opItem} onClick={() => { onAddOp(a.key, o.id); setPick(null); }}>
                  <span className={css.opName}>{o.name}</span>
                  {o.mcSkills.includes(a.mcId) ? <span className={`${css.opMark} ${css.ok} ${css.opPlus}`}>+</span> : null}
                </button>
              ))}
            </div>
          ) : null}
        </span>
      ))}
    </>
  );
}
